(function () {
  function init(root) {
    var toc = root.querySelector('[data-evx-toc]');
    if (!toc) return;
    var links = Array.prototype.slice.call(toc.querySelectorAll('a[data-toc-link]'));
    var targets = links.map(function (a) { return document.getElementById(a.getAttribute('data-toc-link')); }).filter(Boolean);
    if (!targets.length) return;

    var currentLabel = toc.querySelector('[data-evx-toc-current]');
    var toggle = toc.querySelector('[data-evx-toc-toggle]');

    var setActive = function (id) {
      links.forEach(function (a) {
        var match = a.getAttribute('data-toc-link') === id;
        a.classList.toggle('is-active', match);
        if (match && currentLabel) {
          var span = a.querySelector('span');
          currentLabel.textContent = span ? span.textContent : a.textContent;
        }
      });
    };

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) setActive(e.target.id);
      });
    }, { rootMargin: '-30% 0px -55% 0px', threshold: 0 });

    targets.forEach(function (t) { io.observe(t); });

    var getOffset = function () {
      var v = getComputedStyle(root).getPropertyValue('--evx-doc-sticky-top').trim();
      var n = parseInt(v, 10);
      return isNaN(n) ? 130 : n;
    };

    links.forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var id = a.getAttribute('data-toc-link');
        var t = document.getElementById(id);
        if (!t) return;
        ev.preventDefault();
        var top = t.getBoundingClientRect().top + window.pageYOffset - getOffset() - 12;
        window.scrollTo({ top: top, behavior: 'smooth' });
        history.replaceState(null, '', '#' + id);
        root.setAttribute('data-toc-open', 'false');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        var isOpen = root.getAttribute('data-toc-open') === 'true';
        root.setAttribute('data-toc-open', isOpen ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    }

    // close floating dropdown on outside click
    document.addEventListener('click', function (e) {
      if (root.getAttribute('data-toc-open') !== 'true') return;
      if (!toc.contains(e.target)) {
        root.setAttribute('data-toc-open', 'false');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    });

    // initial active from URL hash
    if (location.hash) {
      var initial = location.hash.replace('#', '');
      if (document.getElementById(initial)) setActive(initial);
    } else if (targets[0]) {
      setActive(targets[0].id);
    }
  }

  function boot() {
    document.querySelectorAll('[data-evx-doc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init on Shopify section editor events
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-evx-doc]');
    if (root) init(root);
  });
})();
